import { BaseModel } from '@gipi-shared/models/base.model';

export class SaleEmail extends BaseModel {

    email: string;

    /** @Transient */
    key: number;

}
